import { ReactElement } from 'react';
import { Formik } from 'formik';
import { useNavigate, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { ResetPasswordSchema } from '../../../validators/AuthenticationShema';
import {
    Box,
    Grid,
    Link,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { AuthenticationService } from 'services';
import {
    AppFormikPasswordField,
    AppPrimaryButton,
} from 'shared/components/AppComponents';
import { Utils } from 'shared/helpers';

const ResetPasswordForm = (): ReactElement => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = queryString.parse(location.search);
    const resetPasswordForm = {
        password: '',
    };
    const theme = useTheme();
    const match = useMediaQuery(theme.breakpoints.down('md'));

    // API Calls
    const resetPassword = (formValues: any, callback: any): any => {
        AuthenticationService.resetPassword(formValues)
            .then((response) => {
                console.log('test', response);
                callback(true, response);
            })
            .catch((error) => {
                console.log('test', error);
                callback(false);
                Utils.handleErrorResponse(error);
            });
    };

    // UI Actions
    const actionOnFormSumbit = (formValues: any, formik: any): any => {
        resetPassword(
            { ...formValues, token: queryParams.verificationToken },
            (status: any, response: any) => {
                formik.setSubmitting(false);
                if (status) {
                    Utils.handleSuccessResponse(response);
                    navigate('/login', { replace: true });
                }
            }
        );
    };
    // UI Elements
    return (
        <Box className="reset-password-form-wrapper ">
            <Typography className="title" variant="h2">
                Reset your password
            </Typography>
            <Typography className="subtitle" variant="body1">
                Type your new password to login
            </Typography>

            <Box mt={7}>
                <Formik
                    enableReinitialize
                    initialValues={resetPasswordForm}
                    validationSchema={ResetPasswordSchema}
                    validateOnMount
                    onSubmit={(formValues, formik) => {
                        actionOnFormSumbit(formValues, formik);
                    }}
                >
                    {({ handleSubmit, isSubmitting, isValid }) => (
                        <form autoComplete="off">
                            <Box mt={2}>
                                <AppFormikPasswordField
                                    outerLabel
                                    label="Password *"
                                    name="password"
                                    isCommonCopy
                                />
                            </Box>

                            <Box pt={9}>
                                <Grid
                                    container
                                    spacing={1}
                                    direction={match ? 'column-reverse' : 'row'}
                                >
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={6}
                                        className="start-content"
                                    >
                                        <Typography
                                            className="subtitle"
                                            variant="body1"
                                        >
                                            Are you having problem?
                                            <Typography
                                                variant="body1"
                                                className="subtitle-link-text"
                                            >
                                                Email us at
                                                <Link
                                                    className="subtitle-link"
                                                    href="mailto:support@doxai.co"
                                                >
                                                    support@doxai.co
                                                </Link>
                                            </Typography>
                                        </Typography>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={6}
                                        className="end-content"
                                    >
                                        <AppPrimaryButton
                                            fullWidth
                                            title="Reset Password"
                                            isLoading={isSubmitting}
                                            loadingSize={22}
                                            testid="button-reset"
                                            loadingText="RESETTING"
                                            disabled={isSubmitting || !isValid}
                                            onClick={handleSubmit}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </form>
                    )}
                </Formik>
            </Box>
        </Box>
    );
};

export default ResetPasswordForm;
